export default "__VITE_ASSET__BwKHg9ja__"